import React from "react";
import Profile from "../components/Profile";

const ProfilePage = () => {
  return (
    <section>
      <Profile />
    </section>
  );
};

export default ProfilePage;
